module.exports = __webpack_public_path__ + "static/Logo_CoopOasis-d4f33e33b0a6c6b3d22ad3804854af98.png";